import React from 'react'
import PropTypes from 'prop-types'

function CalendarTitle ({ children, title }) {
  const classNames = [
    'calendar-title',
    'text-gray-400',
    'uppercase',
    'tracking-widest',
    'text-xs',
    'p-2',
    'lg:p-4'
  ]

  return (
    <div className={classNames.join(' ')}>
      {title || children}
    </div>
  )
}

CalendarTitle.propTypes = {
  /**
     * Title to be displayed on the calendar day
     */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ])
}

export default CalendarTitle
